/**
 * Dodge (Shift), shared by every hero: snap into a low forward lean with the arms swept back while
 * the sim's dash carries the unit (no root motion; the legs keep the run cycle under the 'auto'
 * mask), pale speed streaks off the hands and a puff of dust at take-off and landing.
 */
import { ABILITY } from '@keystone/content';
import { type PoseDef, defineClip } from '../clips';
import { registerAbilityClips } from '../registry';

const STREAK = '#d8ecff';
const STREAK_TAIL = '#7fa8d8';

const DODGE_LEAN: PoseDef = {
  spine: [0.55, 0, 0],
  chest: [0.15, 0, 0],
  head: [-0.35, 0, 0],
  rightUpperArm: [-0.8, -0.15, 0.55],
  leftUpperArm: [-0.8, 0.15, 0.55],
  rightLowerArm: [0.4],
  leftLowerArm: [0.4],
};

export const dodge = defineClip({
  id: 'common.dodge',
  duration: 0.42,
  blendIn: 0.02,
  keys: [
    { t: 0.06, ease: 'snap', pose: DODGE_LEAN },
    { t: 0.24, ease: 'linear', pose: { ...DODGE_LEAN, spine: [0.62, 0, 0] } },
    { t: 0.42, ease: 'out' },
  ],
  trails: [{ hand: 'both', from: 0.04, to: 0.26, color: STREAK, tail: STREAK_TAIL, style: 'streak', width: 0.8, fade: 0.18, alpha: 0.55, blend: 'alpha' }],
  cues: [
    { t: 0.02, fx: 'dust', at: 'ground', scale: 0.9 },
    { t: 0.26, fx: 'dust', at: 'ground', scale: 0.6 },
  ],
});

export function registerDodgeClip(): void {
  registerAbilityClips(ABILITY.common.dodge, { strike: dodge });
}
